$(function () {
    $.each($('.alert-danger-remain'), function() {
        var message = $(this).text();
        window.toastr.error(message, null, {timeOut: 0})
    })
})